import { Link } from 'react-router-dom';
import SiteImage from './SiteImage';
import SafeIcon from '../common/SafeIcon';

export default function RoomCard({ room }) {
  return (
    <article className="room-card">
      <Link className="room-image-link" to={`/rooms/${room.number}`} aria-label={`View ${room.title}`}>
        <SiteImage src={room.image} alt={room.alt} className="room-card-image" />
        <span className="room-number">0{room.number}</span>
      </Link>
      <div className="room-card-content">
        <h3>{room.title}</h3>
        <p>{room.description}</p>
        <div className="room-card-bottom">
          <span className="room-price">{room.price}</span>
          <Link className="text-link" to={`/rooms/${room.number}`}>View Room <SafeIcon name="ArrowUpRight" /></Link>
        </div>
      </div>
    </article>
  );
}